import { initializeApp } from "firebase/app";

const config = {
    apiKey: "AIzaSyAdh9O_FCzdH25rfnbOR_pxY9bjawZU5rI",
    authDomain: "hauben-7.firebaseapp.com",
    databaseURL: "https://hauben-7.firebaseio.com",
    projectId: "hauben-7",
    storageBucket: "hauben-7.appspot.com",
    messagingSenderId: "358458408875",
    appId: "1:358458408875:web:98e8c4477cf3bf29599cee"
};

let firebaseApp = null;

export const initFirebaseApp = () => {

    if (firebaseApp !== null) {
        console.log('Firebase App already initialized. Skipping...');
        return;
    }

    firebaseApp = initializeApp(config);
};
